import React, { useContext } from "react";
import { InlineMath } from "react-katex";
import { ThemeContext } from "../../context/ThemeContext";

export default function TreeShadowDiagram({ angle, shadowLength, height }) {
  const { theme } = useContext(ThemeContext);
  const textColor = theme === "light" ? "#000000" : "#ffffff";

  // Stały kąt na rysunku: 35 stopni
  const startX = 40;
  const startY = 180;
  const triangleHeight = 140;
  const radians = (35 * Math.PI) / 180;
  const base = triangleHeight / Math.tan(radians);
  const endX = startX + base;
  const endY = startY - triangleHeight;

  return (
    <svg
      width={base + 80}
      height={220}
      style={{ display: "block", margin: "0 auto", overflow: "visible" }}
    >
      {/* Tło trójkąta */}
      <polygon
        points={`${startX},${startY} ${endX},${startY} ${startX},${endY}`}
        fill={theme === "light" ? "#f9f9f9" : "#000000"}
        stroke="none"
      />

      {/* Pień drzewa – brązowy prostokąt */}
      <rect
        x={startX - 3}
        y={endY}
        width={6}
        height={triangleHeight}
        fill="#8B4513"
        stroke={textColor}
        strokeWidth="1"
      />

      {/* Korona drzewa – zielone koło */}
      <circle
        cx={startX}
        cy={endY + triangleHeight / 4}
        r={triangleHeight / 4}
        fill="#228B22"
        stroke={textColor}
        strokeWidth="1"
      />

      {/* Promień światła – przeciwprostokątna */}
      <line
        x1={startX}
        y1={endY}
        x2={endX}
        y2={startY}
        stroke="#ffcc00"
        strokeWidth="2"
      />

      {/* Cień – przerywana podstawa */}
      <line
        x1={startX}
        y1={startY}
        x2={endX}
        y2={startY}
        stroke={textColor}
        strokeWidth="2"
        strokeDasharray="6,4"
      />

      {/* Etykieta wysokości */}
      <foreignObject x={startX - 30} y={(startY + endY) / 2 } width="40" height="30">
        <div style={{ color: textColor, fontSize: "16px" }}>
          <InlineMath math={typeof height === "number" ? height.toString() : "h"} />
        </div>
      </foreignObject>

      {/* Etykieta cienia */}
      <foreignObject x={(startX + endX) / 2 - 25} y={startY + 8} width="40" height="30">
        <div style={{ color: textColor, fontSize: "16px", textAlign: "center" }}>
          <InlineMath math={typeof shadowLength === "number" ? shadowLength.toString() : "x"} />
        </div>
      </foreignObject>

      {/* Etykieta kąta w prawym dolnym rogu */}
      <foreignObject x={endX - 60} y={startY - 25} width="40" height="30">
        <div style={{ color: textColor, fontSize: "14px" }}>
          <InlineMath math={`${angle}^\\circ`} />
        </div>
      </foreignObject>
    </svg>
  );
}
